import { render, staticRenderFns } from "./tsm-target.vue?vue&type=template&id=4fb937fd&scoped=true"
import script from "./tsm-target.vue?vue&type=script&lang=js"
export * from "./tsm-target.vue?vue&type=script&lang=js"
import style0 from "./tsm-target.vue?vue&type=style&index=0&id=4fb937fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb937fd",
  null
  
)

export default component.exports